import { Injectable, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { take } from 'rxjs/operators';

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { WindowService } from 'src/shared/providers/window.service';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Events } from 'src/providers/events/events';

import { BookJobPage } from 'src/pages/booking/book-job/book-job';
import { PartnerSignupModalComponent } from '../components/partner-signup-modal/partner-signup-modal.component';

@Injectable({
  providedIn: 'root'
})
export class PartnerSignupModalService {

  private modalController = inject(ModalController);
  private rightSidePanelService = inject(RightSidePanelService);
  private navCtrl = inject(CustomNavController);
  private windowService = inject(WindowService);
  private storage = inject(TidyStorage);
  private events = inject(Events);
  private isModalOpen = false;

  async openPartnerSignupModal(partnerCode: string): Promise<void> {
    if (this.isModalOpen) {
      return;
    }
    this.isModalOpen = true;
    const modal = await this.modalController.create({
      component: PartnerSignupModalComponent,
      componentProps: { partnerCode },
      cssClass: 'partner-signup-modal-wrapper',
      backdropDismiss: false
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    this.isModalOpen = false;
    if (data?.address) {
      const params = {
        isSelfBooking: true,
        address: data.address
      };
      if (this.windowService.isDesktopRes) {
        await this.storage.save('dialog-params', params);
        await this.storage.save('dialog-right-side-open', true);
        this.rightSidePanelService.openRightSidePanel(BookJobPage);
        this.rightSidePanelService.afterPanelClosed().pipe(take(1)).subscribe(() => {
          this.events.publish('auth:complete');
        });
      } else {
        this.navCtrl.navigateForward('book-job', params);
      }
    }
  }

  isOpen(): boolean {
    return this.isModalOpen;
  }
}
